import {Component, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../shared/data.service';
import {NgForm} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ResultModel} from './result.model';

@Component({
  selector: 'app-text-analytics',
  templateUrl: './text-analytics.component.html',
  styleUrls: ['./text-analytics.component.css']
})
export class TextAnalyticsComponent implements OnInit {

  @ViewChild('textForm', {static: true}) textForm: NgForm;

  textResponse = [];

  declarativeFormCaptchaValue: any;

  submitted = false;

  constructor(private dataService: DataService,
              private http: HttpClient) {
  }

  ngOnInit(): void {
  }

  onSubmit(textModel: { feature: string; content: string }) {

    console.log(textModel);
    this.submitted = true;


    this.dataService.textFeatureExtract(textModel).subscribe(
      (response) => {

        console.log(response);
        if (textModel.feature === 'nouns') {
          this.textResponse = this.mapToArray(response.result);
        } else if (textModel.feature === 'lemmatize') {
          this.textResponse = response.result.get(textModel.feature);
        } else{
          this.textResponse = this.mapToArray(response.result);
        }

      }
    );
  }

  mapToArray(strMap) {

    const tempList = [];

    strMap.forEach((value: string[], key: string) => {
      console.log(key, value);
      tempList.push(key + '-' + value + '\n');
    });

    return tempList;
  }

}
